import type { FC } from 'react';

import Body from './Body';
import { useSendFeedback } from './hooks/useSendFeedback';
import styles from './styles.module.scss';

const Unavailable: FC = () => {
    useSendFeedback();

    return (
        <div className={styles.wrapper}>
            <Body />
        </div>
    );
};

export default Unavailable;
